var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.146,
    height: 94.514,
    viewBox: "0 0 362.146 94.514",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "features",
    transform: "translate(-23.965 -68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58004",
    "data-name": "Group 58004",
    transform: "translate(-627.889 -346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58010",
    "data-name": "Group 58010",
    transform: "translate(122.928)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_832",
    "data-name": "Ellipse 832",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(823 414)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58005",
    "data-name": "Group 58005",
    transform: "translate(834.773 425.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53673",
    "data-name": "Path 53673",
    d: "M705.01,435.785a1.541,1.541,0,0,1-.752-.195l-4.366-2.391-4.366,2.391a1.554,1.554,0,0,1-1.7-.129,1.728,1.728,0,0,1-.643-1.652l.834-5.062-3.528-3.581a1.742,1.742,0,0,1-.412-1.735,1.638,1.638,0,0,1,1.306-1.148l4.88-.739,2.18-4.607a1.585,1.585,0,0,1,2.9,0l2.183,4.607,4.88.739a1.639,1.639,0,0,1,1.3,1.148,1.743,1.743,0,0,1-.412,1.735l-3.525,3.581.834,5.062a1.735,1.735,0,0,1-.643,1.652A1.567,1.567,0,0,1,705.01,435.785Z",
    transform: "translate(-690 -416)",
    fill: "#1a2d4c"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_411",
    "data-name": "Line 411",
    x2: 87.146,
    transform: "translate(801.426 470.578)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412",
    "data-name": "Line 412",
    x2: 55.758,
    transform: "translate(816.428 488.296)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_413",
    "data-name": "Line 413",
    x2: 55.758,
    transform: "translate(816.428 506.014)",
    fill: "none",
    stroke: "#929faa",
    strokeLinecap: "round",
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58053",
    "data-name": "Group 58053",
    transform: "translate(-897.889 -346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58010-2",
    "data-name": "Group 58010",
    transform: "translate(122.928)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_832-2",
    "data-name": "Ellipse 832",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(823 414)",
    fill: "#f4f5f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58005-2",
    "data-name": "Group 58005",
    transform: "translate(834.773 425.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53673-2",
    "data-name": "Path 53673",
    d: "M705.01,435.785a1.541,1.541,0,0,1-.752-.195l-4.366-2.391-4.366,2.391a1.554,1.554,0,0,1-1.7-.129,1.728,1.728,0,0,1-.643-1.652l.834-5.062-3.528-3.581a1.742,1.742,0,0,1-.412-1.735,1.638,1.638,0,0,1,1.306-1.148l4.88-.739,2.18-4.607a1.585,1.585,0,0,1,2.9,0l2.183,4.607,4.88.739a1.639,1.639,0,0,1,1.3,1.148,1.743,1.743,0,0,1-.412,1.735l-3.525,3.581.834,5.062a1.735,1.735,0,0,1-.643,1.652A1.567,1.567,0,0,1,705.01,435.785Z",
    transform: "translate(-690 -416)",
    fill: "#1a2d4c"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_411-2",
    "data-name": "Line 411",
    x2: 87.146,
    transform: "translate(801.426 470.578)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412-2",
    "data-name": "Line 412",
    x2: 55.758,
    transform: "translate(816.428 488.296)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_413-2",
    "data-name": "Line 413",
    x2: 55.758,
    transform: "translate(816.428 506.014)",
    fill: "none",
    stroke: "#929faa",
    strokeLinecap: "round",
    strokeWidth: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58031",
    "data-name": "Group 58031",
    transform: "translate(-762.889 -346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58010-3",
    "data-name": "Group 58010",
    transform: "translate(122.928)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_832-3",
    "data-name": "Ellipse 832",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(823 414)",
    fill: "#1a2d4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58005-3",
    "data-name": "Group 58005",
    transform: "translate(834.773 425.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53673-3",
    "data-name": "Path 53673",
    d: "M705.01,435.785a1.541,1.541,0,0,1-.752-.195l-4.366-2.391-4.366,2.391a1.554,1.554,0,0,1-1.7-.129,1.728,1.728,0,0,1-.643-1.652l.834-5.062-3.528-3.581a1.742,1.742,0,0,1-.412-1.735,1.638,1.638,0,0,1,1.306-1.148l4.88-.739,2.18-4.607a1.585,1.585,0,0,1,2.9,0l2.183,4.607,4.88.739a1.639,1.639,0,0,1,1.3,1.148,1.743,1.743,0,0,1-.412,1.735l-3.525,3.581.834,5.062a1.735,1.735,0,0,1-.643,1.652A1.567,1.567,0,0,1,705.01,435.785Z",
    transform: "translate(-690 -416)",
    fill: "#f1f5f7"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_411-3",
    "data-name": "Line 411",
    x2: 87.146,
    transform: "translate(801.426 470.578)",
    fill: "none",
    stroke: "#e7e9ed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_412-3",
    "data-name": "Line 412",
    x2: 55.758,
    transform: "translate(816.428 488.296)",
    fill: "none",
    stroke: "#bdc7cf",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_413-3",
    "data-name": "Line 413",
    x2: 55.758,
    transform: "translate(816.428 506.014)",
    fill: "none",
    stroke: "#929faa",
    strokeLinecap: "round",
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/features.40f7289bf37bf01397d55229566735de.svg";
export { ForwardRef as ReactComponent };